module.exports = __webpack_public_path__ + "static/img/banner.f7ed037.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ServiceExperience/banner.jpg
// module id = 00xf
// module chunks = 1